import { Select } from "antd";
import { RootState } from "app.store";
import { useEffect } from "react";
import { shallowEqual, useSelector } from "react-redux";
import { BranchModel } from "states/branch/branch.models";

export interface IBranchSelectorProps {
  value?: number | number[];
  isMultiple?: boolean;
  onChange?: (branch?: BranchModel | BranchModel[]) => void;
  bordered?: boolean;
  textAlign?: "right";
}

export function BranchSelector(props: IBranchSelectorProps) {
  const { value, isMultiple, onChange, bordered, textAlign } = props;
  const branchList = useSelector(
    (state: RootState) => state.branch.branchList,
    shallowEqual
  );

  useEffect(() => {
    if (!value && branchList.length === 1 && onChange) {
      if (isMultiple) {
        onChange(branchList);
      } else {
        onChange(branchList[0]);
      }
    }
  }, [branchList]);

  return (
    <Select
      className={`w-100${textAlign ? ` text-${textAlign}` : ""}`}
      placeholder="Select location"
      value={value}
      onChange={(e) => {
        if (onChange) {
          if (!isMultiple) {
            const branch = branchList.find((m) => m.id === e);
            onChange(branch);
            return;
          }
          if (!e) {
            onChange([]);
            return;
          }
          const ids = e as number[];
          const branchs = [] as BranchModel[];
          ids.forEach((id) => {
            const branch = branchList.find((m) => m.id === id);
            if (branch) {
              branchs.push(branch);
            }
          });
          onChange(branchs);
        }
      }}
      showSearch
      filterOption={(input, option: any) =>
        option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
      }
      mode={isMultiple ? "multiple" : undefined}
      allowClear
      bordered={bordered}
    >
      {branchList.map((branch) => (
        <Select.Option value={branch.id}>{branch.name}</Select.Option>
      ))}
    </Select>
  );
}
